// Scrolling announcement strip above the store header: preorders-live
// announcement with first-drop urgency. Pure CSS marquee (see index.css),
// duplicated content halves make the translateX(-50%) loop seamless.
const LINE =
  "PREORDERS NOW LIVE! ✦ QUANTITY IS LIMITED ✦ SECURE YOUR PAIR NOW ✦ ";

export default function AnnouncementBar() {
  return (
    <div
      data-testid="announcement-bar"
      aria-label="Preorders are now live — first drop quantities are limited"
      className="bg-[#FFD84D] border-b-2 border-ink overflow-hidden py-1.5"
    >
      <div className="flex w-max animate-marquee-x">
        {[0, 1].map((n) => (
          <span
            key={n}
            aria-hidden={n === 1}
            className="font-display uppercase text-xs sm:text-sm tracking-[0.12em] text-ink whitespace-nowrap"
          >
            {LINE.repeat(5)}
          </span>
        ))}
      </div>
    </div>
  );
}
